module.exports = __webpack_public_path__ + "media/icon_transaction/cat_4-90f7c9c0.png";